import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnumerationGetService } from './enumeration.service';

@NgModule({
  imports: [CommonModule],
  providers: [EnumerationGetService],
})
export class EnumerationModule {}
